export function espace_mille(nombre,digit){
    let number
    let prepend
    let append
    let numToConvert

    // digit peut être undefined chez certains appelants (ex. imprime.jsx) : sans ce fallback,
    // toFixed(undefined) équivaut à toFixed(0) mais laisse nb[1] undefined plus bas, ce qui
    // ajoutait littéralement ".undefined" au prix imprimé.
    if(digit==null) digit = 0

    if(digit==0 || nombre=='' || Number.isInteger(+nombre)){
        numToConvert = (nombre=='') ? nombre : Math.trunc(+nombre).toString()
        append = ''

    }else{
        let initNum = Number(nombre).toFixed(digit)
        let nb = initNum.split('.')
        numToConvert = nb[0]
        append = '.'+nb[1]
    }

    if(numToConvert.toString().startsWith("-")){
        number = numToConvert.toString().replace('-','')
        prepend = '-'
    }else{
        number = numToConvert
        prepend = ''
    }

    if(number<=999) return prepend+number.toString()+append;
    if(number<=999999) return prepend+number.toString().slice(0,number.toString().length-3)+' '+number.toString().slice(-3)+append;
    if(number<=999999999) return prepend+number.toString().slice(0,number.toString().length-6)+' '+number.toString().slice(-6,-3)+' '+number.toString().slice(-3)+append;
}